import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/devicemanage/carme.png'


const _withScopeId = n => (_pushScopeId("data-v-488003aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filterbox" }
const _hoisted_2 = { class: "devicelist" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "device-img",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "device-info" }
const _hoisted_5 = { class: "device-name" }
const _hoisted_6 = { class: "device-loc" }
const _hoisted_7 = { style: {"height":"100%","display":"flex","align-items":"flex-start"} }
const _hoisted_8 = { class: "popupblock" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popuptitle" }, "设备选择", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupblock-t" }, "设备类型", -1))
const _hoisted_11 = { class: "popupblock-c" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupblock-t" }, "设备状态", -1))
const _hoisted_14 = { class: "popupblock-c" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "btnbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
    }, {
      right: _withCtx(() => [
        _createVNode(_component_svg_icon, {
          "icon-class": "filter",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupShow = true))
        })
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_search, {
        modelValue: _ctx.paramObj.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paramObj.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "请输入搜索关键词",
        clearable: "",
        onSearch: _ctx.fSearch
      }, null, 8, ["modelValue", "onSearch"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": "没有更多了",
            onLoad: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "devicelist-item",
                  key: index
                }, [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_6, " 类型：" + _toDisplayString(_ctx.deviceNameList[item.deviceType - 1].name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["device-status", { _success: item.status === 1, _fail: item.status === 0 }])
                    }, _toDisplayString(item.status === 1 ? "在线" : "离线"), 3)
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.popupShow) = $event)),
      position: "top",
      closeable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceTypeList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["selectitem", { _active: _ctx.isSelectDevice(item.id) }]),
                key: index,
                onClick: ($event: any) => (_ctx.fDeviceTypeTagClick(item))
              }, _toDisplayString(item.name), 11, _hoisted_12))
            }), 128))
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["selectitem", { _active: item.id === _ctx.paramObj.status }]),
                key: index,
                onClick: ($event: any) => (_ctx.fDeviceStatusTagClick(item))
              }, _toDisplayString(item.name), 11, _hoisted_15))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "btn submit-btn",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fResetBtn && _ctx.fResetBtn(...args)))
            }, "重置"),
            _createElementVNode("div", {
              class: "btn submit-btn",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fSureBtn && _ctx.fSureBtn(...args)))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}